import { useState, useRef, useEffect, useCallback } from 'react';

interface UseDropdownReturn {
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
    ref: React.RefObject<HTMLDivElement | null>;
}

export const useDropdown = (): UseDropdownReturn => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const toggle = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    const close = useCallback(() => {
        setIsOpen(false);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                close();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, close]);

    return { isOpen, toggle, close, ref };
};
